<div class="template-a-editor">
    <div class="editor-sections">
        <!-- Header Logo Section -->
        <div class="editor-section">
            <h5 class="section-title">Header Logo</h5>
            <p class="image-size-hint">Maximum file size: 1MB</p>
            <div class="image-upload-container">
                <input
                    type="file"
                    accept="image/*"
                    (change)="onHeaderLogoChange($event)"
                    #headerLogoUpload
                    class="file-input"
                />
                <button
                    mat-raised-button
                    color="primary"
                    (click)="headerLogoUpload.click()"
                    [disabled]="isUploadingHeaderLogo"
                    class="upload-btn"
                >
                    <mat-icon>cloud_upload</mat-icon>
                    Upload Logo
                </button>

                <div *ngIf="isUploadingHeaderLogo" class="upload-spinner">
                    <mat-spinner diameter="30"></mat-spinner>
                </div>

                <div *ngIf="templateData.headerLogoUrl && !isUploadingHeaderLogo" class="image-preview">
                    <img [src]="templateData.headerLogoUrl" alt="Header Logo Preview" />
                    <button
                        mat-icon-button
                        color="warn"
                        (click)="removeHeaderLogo()"
                        class="remove-btn"
                        matTooltip="Remove Image"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- Images Section -->
        <div class="editor-section">
            <h5 class="section-title">Images</h5>
            <p class="image-size-hint">Maximum file size: 1MB per image</p>
            <div class="subheader-images-container">
                <!-- Subheader Image 1 -->
                <div class="subheader-image">
                    <h6>Image 1</h6>
                    <div class="image-upload-container">
                        <input
                            type="file"
                            accept="image/*"
                            (change)="onSubheader1Change($event)"
                            #subheader1Upload
                            class="file-input"
                        />
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="subheader1Upload.click()"
                            [disabled]="isUploadingSubheader1"
                            class="upload-btn"
                        >
                            <mat-icon>cloud_upload</mat-icon>
                            Upload
                        </button>

                        <div *ngIf="isUploadingSubheader1" class="upload-spinner">
                            <mat-spinner diameter="30"></mat-spinner>
                        </div>

                        <div *ngIf="templateData.subheaderImage1Url && !isUploadingSubheader1" class="image-preview">
                            <img [src]="templateData.subheaderImage1Url" alt="Subheader Image 1 Preview" />
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="removeSubheader1()"
                                class="remove-btn"
                                matTooltip="Remove Image"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Subheader Image 2 -->
                <div class="subheader-image">
                    <h6>Image 2</h6>
                    <div class="image-upload-container">
                        <input
                            type="file"
                            accept="image/*"
                            (change)="onSubheader2Change($event)"
                            #subheader2Upload
                            class="file-input"
                        />
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="subheader2Upload.click()"
                            [disabled]="isUploadingSubheader2"
                            class="upload-btn"
                        >
                            <mat-icon>cloud_upload</mat-icon>
                            Upload
                        </button>

                        <div *ngIf="isUploadingSubheader2" class="upload-spinner">
                            <mat-spinner diameter="30"></mat-spinner>
                        </div>

                        <div *ngIf="templateData.subheaderImage2Url && !isUploadingSubheader2" class="image-preview">
                            <img [src]="templateData.subheaderImage2Url" alt="Subheader Image 2 Preview" />
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="removeSubheader2()"
                                class="remove-btn"
                                matTooltip="Remove Image"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Bottom Right Image (Image 3) -->
                <div class="subheader-image">
                    <h6>Image 3 (Bottom Right)</h6>
                    <div class="image-upload-container">
                        <input
                            type="file"
                            accept="image/*"
                            (change)="onBottomImageChange($event)"
                            #bottomImageUpload
                            class="file-input"
                        />
                        <button
                            mat-raised-button
                            color="primary"
                            (click)="bottomImageUpload.click()"
                            [disabled]="isUploadingBottomImage"
                            class="upload-btn"
                        >
                            <mat-icon>cloud_upload</mat-icon>
                            Upload
                        </button>

                        <div *ngIf="isUploadingBottomImage" class="upload-spinner">
                            <mat-spinner diameter="30"></mat-spinner>
                        </div>

                        <div *ngIf="templateData.bottomRightImageUrl && !isUploadingBottomImage" class="image-preview">
                            <img [src]="templateData.bottomRightImageUrl" alt="Bottom Image Preview" />
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="removeBottomImage()"
                                class="remove-btn"
                                matTooltip="Remove Image"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Body Content Section -->
        <div class="editor-section">
            <h5 class="section-title">Email Body Content</h5>
            <app-text-editor
                [(ngModel)]="templateData.bodyHtml"
                (ngModelChange)="onBodyContentChange($event)"
                placeholder="Enter email body content here..."
                height="400px"
            ></app-text-editor>
        </div>


        <!-- Preview Button -->
        <div class="editor-section preview-section">
            <button
                mat-raised-button
                color="accent"
                (click)="generatePreview()"
                [disabled]="isGeneratingPreview"
                class="preview-btn"
            >
                <mat-icon>preview</mat-icon>
                Preview Generated Email
            </button>
        </div>
    </div>
</div>
